var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "cashbox-details container container_30" }, [
    _vm.showKYC
      ? _c(
          "div",
          { staticClass: "cashbox-user__list-wrp" },
          [
            _c("cashbox-user", {
              attrs: {
                id: _vm.details.requestorId,
                email: _vm.details.requestor
              },
              on: {
                "close-kyc": function($event) {
                  return _vm.showKYCForm(false)
                }
              }
            })
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.showKYC
      ? _c(
          "div",
          { staticClass: "cashbox-details__form" },
          [
            _c(
              "div",
              { staticClass: "cashbox-details__back" },
              [
                _c(
                  "md-button",
                  {
                    staticClass: "cashbox-details__back-btn md-icon-button",
                    on: { click: _vm.closeForm }
                  },
                  [
                    _c("md-icon", [_vm._v("keyboard_arrow_left")]),
                    _vm._v(" "),
                    _c("md-tooltip", { attrs: { "md-direction": "top" } }, [
                      _vm._v(_vm._s(_vm.i18n.lbl_go_back()))
                    ])
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "form",
              {
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return _vm.closeForm.apply(null, arguments)
                  }
                }
              },
              [
                _c("div", [
                  _c(
                    "div",
                    { staticClass: "md-title cashbox-details__title" },
                    [_vm._v(_vm._s(_vm.i18n.withdraw_details()))]
                  ),
                  _vm._v(" "),
                  _c("div", [
                    _c("div", [
                      _c("span", [_vm._v(_vm._s(_vm.i18n.lim_request_id()))]),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.id))])
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c("span", [
                        _vm._v(_vm._s(_vm.i18n.lbl_request_state()))
                      ]),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.getStateText()))])
                    ]),
                    _vm._v(" "),
                    _vm.details.destination &&
                    _vm.details.destination.length > 0
                      ? _c("div", [
                          _c("span", [
                            _vm._v(_vm._s(_vm.i18n.withdraw_ex_address()))
                          ]),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(_vm.details.destination))])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.details.rejectReason &&
                    _vm.details.rejectReason.length > 0
                      ? _c("div", [
                          _c("span", [
                            _vm._v(_vm._s(_vm.i18n.lbl_reject_reason()))
                          ]),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(_vm.details.rejectReason))])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.details.requestor && _vm.details.requestor.length > 0
                      ? _c("div", [
                          _c(
                            "span",
                            [
                              _c(
                                "md-content",
                                {
                                  staticClass: "kyc-button",
                                  on: {
                                    click: function($event) {
                                      return _vm.showKYCForm(true)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(_vm.i18n.lbl_requestor()) +
                                      "\n                "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "md-tooltip",
                                { attrs: { "md-direction": "left" } },
                                [_vm._v(_vm._s(_vm.i18n.lbl_kyc()))]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(_vm.details.requestor))])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", [
                      _c("span", [
                        _vm._v(_vm._s(_vm.i18n.lbl_requestor_account_id()))
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(_vm._s(_vm.details.requestorId) + " ")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c("span", [
                        _vm._v(_vm._s(_vm.i18n.lbl_source_amount()))
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.details.amount) +
                            " " +
                            _vm._s(_vm.details.destAssetCode)
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c("span", [
                        _vm._v(_vm._s(_vm.i18n.lbl_destination_amount()))
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.details.amount) +
                            " " +
                            _vm._s(_vm.details.destAssetCode)
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c("span", [_vm._v(_vm._s(_vm.i18n.lbl_fixed_fee()))]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.details.fixedFee) +
                            " " +
                            _vm._s(_vm.details.destAssetCode)
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c("span", [_vm._v(_vm._s(_vm.i18n.lbl_percent_fee()))]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.details.percentFee) +
                            " " +
                            _vm._s(_vm.details.destAssetCode)
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c("span", [_vm._v(_vm._s(_vm.i18n.lbl_total_fee()))]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.details.totalFee) +
                            " " +
                            _vm._s(_vm.details.destAssetCode)
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.balance
                      ? _c("div", [
                          _c("span", [_vm._v(_vm._s(_vm.i18n.lbl_balance()))]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.balance) +
                                " " +
                                _vm._s(_vm.details.destAssetCode)
                            )
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", [
                      _c("span", [_vm._v(_vm._s(_vm.i18n.withdraw_created()))]),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.details.created))])
                    ]),
                    _vm._v(" "),
                    _vm.details.requestStateI !== _vm.REQUEST_STATES.pending
                      ? _c("div", [
                          _c("span", [
                            _vm._v(_vm._s(_vm.getDateTitleByState()))
                          ]),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(_vm.details.updated))])
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "btn-wrap space-between margin-top" },
                    [
                      _vm.details.requestStateI === 1
                        ? [
                            _c(
                              "md-button",
                              {
                                staticClass: "btn btn_narrow md-primary",
                                attrs: { disabled: _vm.isSubmitting },
                                on: {
                                  click: function($event) {
                                    return _vm.fulfill()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.i18n.withdraw_approve()) +
                                    "\n            "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "md-button",
                              {
                                staticClass: "btn btn_narrow md-primary",
                                attrs: { disabled: _vm.isSubmitting },
                                on: {
                                  click: function($event) {
                                    return _vm.selectForRejection()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.i18n.withdraw_reject()) +
                                    "\n            "
                                )
                              ]
                            )
                          ]
                        : [
                            _c(
                              "md-button",
                              {
                                staticClass: "btn btn_narrow md-primary",
                                on: { click: _vm.closeForm }
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.i18n.lbl_close()) +
                                    "\n            "
                                )
                              ]
                            )
                          ]
                    ],
                    2
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _vm.showRejectConfirm
              ? _c(
                  "modal",
                  {
                    attrs: { "max-width": "40rem" },
                    on: {
                      "close-request": function($event) {
                        return _vm.clearRejectionSelection()
                      }
                    }
                  },
                  [
                    _c(
                      "form",
                      {
                        attrs: { id: "details-reject-form" },
                        on: {
                          submit: function($event) {
                            $event.preventDefault()
                            _vm.reject() && _vm.clearRejectionSelection()
                          }
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "details-reject__form-row" },
                          [
                            _c("input-field", {
                              staticClass: "reject_reason-input",
                              attrs: {
                                name: "reject_reason",
                                label: _vm.i18n.withdraw_reject_reason_prompt()
                              },
                              on: { input: _vm.clearRejectFromError },
                              model: {
                                value: _vm.rejectForm.reason,
                                callback: function($$v) {
                                  _vm.$set(_vm.rejectForm, "reason", $$v)
                                },
                                expression: "rejectForm.reason"
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.formErrors.confirmReject.error,
                                    expression: "formErrors.confirmReject.error"
                                  }
                                ],
                                staticClass: "small_danger"
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.formErrors.confirmReject.message
                                    ) +
                                    "\n        "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "btn-wrap space-between margin-top" },
                      [
                        _c(
                          "md-button",
                          {
                            staticClass: "btn btn_narrow md-primary",
                            attrs: {
                              form: "details-reject-form-reject-form",
                              disabled: _vm.isSubmitting
                            },
                            on: {
                              click: function($event) {
                                _vm.validateRejectReason() && _vm.reject()
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.i18n.withdraw_reject()) +
                                "\n        "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "md-button",
                          {
                            staticClass: "btn btn_narrow md-primary",
                            attrs: { disabled: _vm.isSubmitting },
                            on: { click: _vm.clearRejectionSelection }
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.i18n.lbl_cancel()) +
                                "\n        "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ]
                )
              : _vm._e()
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9c245590", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9c245590","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/cashbox/index/Cashbox.Details.vue
// module id = QnJZ
// module chunks = 1